export default __webpack_public_path__ + "static/Row 2.2_Far Eastern Kindergarten-88d7403f8e1c03b90ec8f88a4a9d55ab.jpg";